import Palettes from "../Domain/Palette/Store/Palettes";

export default {
    namespaced: true,

    state: {
        id               : 0,
        activeSwatchIndex: 0,
    },

    getters: {
        palette(state) {
            return new Palettes().getPaletteById(state.id);
        },

        activeSwatch(state, getters) {
            if(getters.palette == null) return;

            return getters.palette.swatches[state.activeSwatchIndex];
        },

        swatchCount(state, getters) {
            if(getters.palette == null) return;
            
            return getters.palette.swatches.length;
        }
    },

    mutations: {
        setPalette(state, paletteId) {
            state.id = paletteId;
        },

        setActiveSwatch(state, index) {
            state.activeSwatchIndex = index;
        },

    },
}
